import React from "react";
import { Link } from "react-router-dom";
import { app } from './firebaseconfig'
class Header1 extends React.Component{

	constructor() {
		super();
		this.state = ({
		  user: null,
		});
		this.authListener = this.authListener.bind(this);
	  }
	
	  componentDidMount() {
		this.authListener();
	  }
	
	  authListener() {
		app.auth().onAuthStateChanged((user) => {
		  if (user) {
			this.setState({ user });
			localStorage.setItem('user', user.uid);
		  } else {
			this.setState({ user: null });
			localStorage.removeItem('user');
		  }
		});
	  }
    
   logout = () => {
        app.auth().signOut().then(function() {
          }).catch(function(error) {
            console.log(error)
		  });
		  window.location.reload(false);
    } 

    loggedin = () => {
        app.auth().onAuthStateChanged(function(user) {
            if (user) {
              return true
            } else {
              return false
            }
        });
    }

	
render(){
    return (
        <div>
			
				<header id="header" className="alt">
					<h1><a href="/">UOB Notes</a></h1>
					<nav id="nav">
						<ul>
						<script data-ad-client="ca-pub-6388089627501969" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
							<li><a href="/">Home</a></li>
							{	
							app.auth().currentUser ? 
							(<li><a onClick={this.logout} className="button">Logout</a></li>) : 
							(<li><a href="/Signup" className="button">Sign Up</a></li>)
							}
							{	
							this.state.user ? 
							(<div></div>):
							(<li><a href="/login" className="button"> Sign in</a></li>)
							}

						

						
						</ul>
						
					</nav>
				</header>
            
        </div>
    );
};
}
export default Header1;
